<div class="text-center">
    <div> Date &nbsp;&nbsp;:&nbsp;{{data.obj.date}}</div>
    <br>
    <div> Title &nbsp;&nbsp;:&nbsp;{{data.obj.name}}</div>
    <br>
    <div>
        <angular-file-uploader [config]="afuConfig"></angular-file-uploader>
    </div>
</div>
